import React, { useState, useRef } from 'react';
import './sub1.css';
import { Helmet } from 'react-helmet';
import emailjs from "@emailjs/browser";
import contactConfig from '../../confi';
const Service = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedServices, setSelectedServices] = useState([]);
  const [urgency, setUrgency] = useState('');
  const [preferredGender, setPreferredGender] = useState('');

  const services = [
    {
      id: 'cleaning',
      name: 'Maid Service',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuCZHslxxObZUUAdLZSMKqh6nPsNZYGroF0A&s',
      description: 'Thorough Maid Service to keep your home spotless and organized.'
    },
    {
      id: 'cooking',
      name: 'Cooking',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSF2JICOrSGQNwuo_iftlmyTWTOqMyKJARcRw&s',
      description: 'Expert cooks to prepare delicious and healthy meals for your family.'
    },
    {
      id: 'baby-sitting',
      name: 'Baby Sitting',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXwt8urZ-P1M6DwVtJOOjqPfJO_PM3iPBjzw&s',
      description: 'Reliable and caring babysitters to look after your little ones.'
    },
    {
      id: 'elderly-care',
      name: 'Elderly Care',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCslZsrymX_VpEB1E6_BqxrJGrSDmL17nT_g&s',
      description: 'Compassionate care for elderly family members.'
    },
    {
      id: 'driver',
      name: 'Driver',
      icon: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80',
      description: 'Professional drivers for your transportation needs.'
    },
    {
      id: 'pet-care',
      name: 'Patient Care',
      icon: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80',
      description: 'Loving Patient Care for your furry family members.'
    }
  ];

  const urgencyOptions = [
    {
      id: 'urgent',
      title: 'Urgent requirement',
      description: 'We will contact you as soon as possible'
    },
    {
      id: 'not-urgent',
      title: 'Not so urgent requirement',
      description: 'We will contact you within 7 working days'
    },
    {
      id: 'checking',
      title: 'Just checking the site',
      description: 'We will not contact you'
    }
  ];

  const genderOptions = [
    { id: 'male', label: 'Male' },
    { id: 'female', label: 'Female' },
    { id: 'any', label: 'Any' }
  ];

  const handleServiceToggle = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleContinue = () => {
    if (currentStep === 1 && selectedServices.length === 0) {
      alert('Please select at least one service');
      return;
    }
    if (currentStep === 2 && !urgency) {
      alert('Please select urgency level');
      return;
    }
    if (currentStep === 3 && !preferredGender) {
      alert('Please select preferred gender');
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleGenderSelect = (gender) => {
    setPreferredGender(gender);
    // Auto-proceed to registration form after gender selection
    setTimeout(() => {
      setCurrentStep(4);
    }, 500);
  };

  const handleSubmit = (formData) => {
    // Handle form submission
    console.log('Form submitted:', {
      services: selectedServices,
      urgency,
      preferredGender,
      ...formData
    });
    alert('Thank you for your registration! We will contact you soon.');
  };
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="service">
      <Helmet>
        {/* ---------- BASIC SEO META ---------- */}
        <title>Book your Post Requirement in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="Looking for trusted domestic help in Ahmedabad or Surat? Get post requirements with JP Home Services or call +918780438907 to hire verified staff fast."
        />
        <meta
          name="keywords"
          content="post job requirement, hire maid in ahmedabad, cook services gujarat, babysitter agency, domestic help requirement form, jp home services, home staff hiring"
        />
        <meta name="robots" content="index, follow" />

        {/* ---------- CANONICAL URL ---------- */}
        <link rel="canonical" href="https://jphomeservice.in/post-requirement" />

        {/* ---------- OPEN GRAPH (FACEBOOK / LINKEDIN) ---------- */}
        <meta
          property="og:title"
          content="Book your Post Requirement in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content="Looking for trusted domestic help in Ahmedabad or Surat? Get post requirements with JP Home Services or call +918780438907 to hire verified staff fast."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jphomeservice.in/post-requirement" />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* ---------- TWITTER CARD ---------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Book your Post Requirement in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="Looking for trusted domestic help in Ahmedabad or Surat? Get post requirements with JP Home Services or call +918780438907 to hire verified staff fast."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* ---------- STRUCTURED DATA (JSON-LD) ---------- */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Post Your Requirement - JP Home Services",
              "url": "https://jphomeservice.in/post-requirement",
              "description": "Post your job requirement to hire verified maids, cooks, babysitters, and caretakers with JP Home Services in Ahmedabad and across Gujarat.",
              "publisher": {
                "@type": "Organization",
                "name": "JP Home Services",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
                }
              },
              "potentialAction": {
                "@type": "Action",
                "name": "Post Requirement Form Submission",
                "target": "https://jphomeservice.in/post-requirement"
              },
              "mainEntity": {
                "@type": "Organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in",
                "logo": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+919327365056",
                  "contactType": "Customer Service"
                },
                "sameAs": [
                  "https://www.facebook.com/jphomeservice.in/",
                  "https://www.instagram.com/jp_home_service/"
                ]
              }
            }
            `}
        </script>
      </Helmet>
      <section className="blog-hero-section1">
        <div className="blog-hero-content1">
          <h1>Post Requirement</h1>
          <p>Discover helpful tips, insights, and stories about housekeeping, parenting, and home care</p>
        </div>
      </section>

      <div className="floating-contact-icons">
        <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
          </svg>
        </div>
        <div
          className="contact-icon call-icon"
          onClick={handleCall}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
            <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
          </svg>
        </div>
      </div>
      <section className="service-content">
        <div className="form-container">
          {/* Progress Bar */}
          <div className="progress-bar">
            <div className="progress-step">
              <div className={`step-number ${currentStep >= 1 ? 'active' : ''}`}>1</div>
              <span className="step-label">Services</span>
            </div>
            <div className="progress-line"></div>
            <div className="progress-step">
              <div className={`step-number ${currentStep >= 2 ? 'active' : ''}`}>2</div>
              <span className="step-label">Urgency</span>
            </div>
            <div className="progress-line"></div>
            <div className="progress-step">
              <div className={`step-number ${currentStep >= 3 ? 'active' : ''}`}>3</div>
              <span className="step-label">Gender</span>
            </div>
            <div className="progress-line"></div>
            <div className="progress-step">
              <div className={`step-number ${currentStep >= 4 ? 'active' : ''}`}>4</div>
              <span className="step-label">Register</span>
            </div>
          </div>

          {/* Step 1: Service Selection */}
          {currentStep === 1 && (
            <div className="step-content">
              <h2>What type of maids are you looking for?</h2>
              <div className="services-grid">
                {services.map(service => (
                  <div
                    key={service.id}
                    className={`service-card ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                    onClick={() => handleServiceToggle(service.id)}
                  >
                    <img src={service.icon} alt={service.name} />
                    <h3>{service.name}</h3>
                    <p>{service.description}</p>
                    <div className="checkmark">✓</div>
                  </div>
                ))}
              </div>
              <button
                className="continue-btn"
                onClick={handleContinue}
                disabled={selectedServices.length === 0}
              >
                Continue
              </button>
            </div>
          )}

          {/* Step 2: Urgency Selection */}
          {currentStep === 2 && (
            <div className="step-content">
              <h2>How urgent is your requirement?</h2>
              <div className="urgency-options">
                {urgencyOptions.map(option => (
                  <div
                    key={option.id}
                    className={`urgency-card ${urgency === option.id ? 'selected' : ''}`}
                    onClick={() => setUrgency(option.id)}
                  >
                    <h3>{option.title}</h3>
                    <p>{option.description}</p>
                    <div className="radio-dot"></div>
                  </div>
                ))}
              </div>
              <div className="button-group">
                <button
                  className="back-btn"
                  onClick={handleContinue}
                  disabled={!urgency}
                >
                  Continue
                </button>
                <button className="back-btn" onClick={handleBack}>
                  Back
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Gender Preference */}
          {currentStep === 3 && (
            <div className="step-content">
              <h2>Which gender do you prefer?</h2>
              <p className="subtitle">Select preferred Gender</p>
              <div className="gender-options">
                {genderOptions.map(option => (
                  <div
                    key={option.id}
                    className={`gender-card ${preferredGender === option.id ? 'selected' : ''}`}
                    onClick={() => handleGenderSelect(option.id)}
                  >
                    <div className="gender-icon">
                      {option.id === 'male' && '👨'}
                      {option.id === 'female' && '👩'}
                      {option.id === 'any' && '👥'}
                    </div>
                    <span>{option.label}</span>
                  </div>
                ))}
              </div>
              <div className="button-group">
                <button className="back-btn" onClick={handleBack}>
                  Back
                </button>
                {/* <button 
                  className="back-btn"
                  onClick={handleContinue}
                >
                  Continue
                </button> */}
              </div>
            </div>
          )}

          {/* Step 4: Registration Form */}
          {currentStep === 4 && (
            <RegistrationForm
              onSubmit={handleSubmit}
              onBack={handleBack}
              selectedData={{
                services: selectedServices,
                urgency,
                preferredGender
              }}
              services={services}
              urgencyOptions={urgencyOptions}
              genderOptions={genderOptions}
            />
          )}
        </div>
      </section>
    </div>
  );
};

// Registration Form Component
const RegistrationForm = ({ onSubmit, onBack, selectedData, services, urgencyOptions, genderOptions }) => {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   phone: '',
  //   email: '',
  //   address: '',
  //   pincode: '',
  //   requirements: ''
  // });
  const form = useRef();
  const [loading, setLoading] = useState(false);

  // const handleChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value
  //   });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   onSubmit(formData);
  // };
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC"
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="step-content">
      <h2>Complete Your Registration</h2>

      {/* Selected Options Summary */}
      <div className="selected-summary">
        <h4>Your Selections:</h4>
        <p><strong>Services:</strong> {selectedData.services.map(service => services.find(s => s.id === service)?.name).join(', ')}</p>
        <p><strong>Urgency:</strong> {urgencyOptions.find(o => o.id === selectedData.urgency)?.title}</p>
        <p><strong>Preferred Gender:</strong> {genderOptions.find(o => o.id === selectedData.preferredGender)?.label}</p>
      </div>

      <form
        className="contact-form"
        ref={form}
        onSubmit={sendEmail}
      >
        {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

        <div className="form-group">
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Your Name*"
            required
          />
        </div>

        <div className="form-group">
          <input
            type="email"
            id="email"
            name="emailid"
            placeholder="Email Address*"
            required
          />
        </div>

        <div className="form-group">
          <input
            type="tel"
            id="phone"
            name="contactno"
            placeholder="Phone Number*"
            required
          />
        </div>


        <div className="form-row">
          <div className="form-group">
            <select id="category" required name="ServiceRequired">
              <option value="">Choose a category</option>
              <option value="House Maid">House Maid</option>
              <option value="Baby Sitting">Baby Sitting</option>
              <option value="Elderly Care">Elderly Care</option>
              <option value="Patient Care">Patient Care</option>
              <option value="Cook">Cook</option>
              <option value="Driver">Driver</option>
              <option value="Full Time Servant">
                24x7 Servant
              </option>
              <option value="Office Boy">Office Boy</option>
              <option value="Pet Care">Pet Care</option>
            </select>
          </div>
        </div>

        {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

        <button
          type="submit"
          className="submit-btn1"
          disabled={loading}
          onClick={() => {
            return window.gtag_report_conversion
              ? window.gtag_report_conversion("https://jphomeservice.in/")
              : true;
          }}
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
        <button type="button" className="submit-btn1" onClick={onBack}>
          Back
        </button>
      </form>
    </div>
  );
};

export default Service;